export const scrollToBottom = (element: HTMLTextAreaElement) => {
  element.scroll({ top: element.scrollHeight });
};
